import { render, staticRenderFns } from "./DataStepFive.vue?vue&type=template&id=68e7eb8e&scoped=true&"
import script from "./DataStepFive.vue?vue&type=script&lang=js&"
export * from "./DataStepFive.vue?vue&type=script&lang=js&"
import style0 from "./DataStepFive.vue?vue&type=style&index=0&id=68e7eb8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e7eb8e",
  null
  
)

export default component.exports